export default "__VITE_ASSET__DpYAlWgW__"